/**
 * Registre d'icônes de Centime : Hugeicons, style stroke-rounded (pack gratuit).
 * Seules les icônes listées ici existent dans l'application. Les importer ailleurs est interdit
 * (règle ESLint) : on garantit ainsi un jeu cohérent et un bundle minimal.
 */
import {
  Activity01Icon,
  Add01Icon,
  Alert02Icon,
  Analytics01Icon,
  Archive02Icon,
  ArrowDataTransferHorizontalIcon,
  ArrowDownLeft01Icon,
  ArrowDown01Icon,
  ArrowLeft01Icon,
  ArrowRight01Icon,
  ArrowUp01Icon,
  ArrowUpRight01Icon,
  Baby01Icon,
  BankIcon,
  BirthdayCakeIcon,
  Book02Icon,
  Briefcase01Icon,
  Building03Icon,
  Bus01Icon,
  Calendar03Icon,
  Cancel01Icon,
  Car01Icon,
  Cash01Icon,
  ChurchIcon,
  Clock01Icon,
  CloudUploadIcon,
  Coffee02Icon,
  Delete02Icon,
  Download04Icon,
  Dumbbell01Icon,
  Edit02Icon,
  ElectricHome01Icon,
  EyeIcon,
  EyeOffIcon,
  Film02Icon,
  FilterHorizontalIcon,
  FingerPrintIcon,
  FuelIcon,
  GameController03Icon,
  GasStoveIcon,
  GiftIcon,
  HeartIcon,
  Home01Icon,
  Hospital01Icon,
  InformationCircleIcon,
  InternetAntenna01Icon,
  KeyboardIcon,
  LockKeyIcon,
  Logout02Icon,
  Mail01Icon,
  Medicine02Icon,
  Mosque01Icon,
  MoreHorizontalIcon,
  Motorbike01Icon,
  Music01Icon,
  Notification01Icon,
  PartyIcon,
  PawPrintIcon,
  PiggyBankIcon,
  PlaneIcon,
  Plant01Icon,
  Refresh01Icon,
  RepeatIcon,
  Restaurant01Icon,
  School01Icon,
  Search01Icon,
  Settings01Icon,
  Shield01Icon,
  SentIcon,
  ShoppingBag01Icon,
  SmartPhone01Icon,
  TShirtIcon,
  Target02Icon,
  TaxiIcon,
  Ticket01Icon,
  Tick02Icon,
  UserCircleIcon,
  Wallet01Icon,
  WaterPumpIcon,
  WifiOff01Icon,
  Wrench01Icon,
} from '@hugeicons/core-free-icons'

/** Données d'une icône : liste d'éléments SVG `[balise, attributs]` dans un carré 24 × 24. */
export type IconData = readonly (readonly [string, Readonly<Record<string, string | number>>])[]

/** Icônes de l'interface. */
const interfaceIcons = {
  home: Home01Icon,
  envelopes: Wallet01Icon,
  add: Add01Icon,
  activity: Activity01Icon,
  analytics: Analytics01Icon,
  settings: Settings01Icon,
  account: UserCircleIcon,
  back: ArrowLeft01Icon,
  forward: ArrowRight01Icon,
  'chevron-down': ArrowDown01Icon,
  'chevron-up': ArrowUp01Icon,
  close: Cancel01Icon,
  check: Tick02Icon,
  search: Search01Icon,
  calendar: Calendar03Icon,
  clock: Clock01Icon,
  lock: LockKeyIcon,
  protected: Shield01Icon,
  alert: Alert02Icon,
  info: InformationCircleIcon,
  delete: Delete02Icon,
  download: Download04Icon,
  edit: Edit02Icon,
  more: MoreHorizontalIcon,
  notification: Notification01Icon,
  offline: WifiOff01Icon,
  sync: CloudUploadIcon,
  refresh: Refresh01Icon,
  transfer: ArrowDataTransferHorizontalIcon,
  income: ArrowDownLeft01Icon,
  expense: ArrowUpRight01Icon,
  recurring: RepeatIcon,
  archive: Archive02Icon,
  filter: FilterHorizontalIcon,
  logout: Logout02Icon,
  mail: Mail01Icon,
  send: SentIcon,
  fingerprint: FingerPrintIcon,
  keyboard: KeyboardIcon,
  show: EyeIcon,
  hide: EyeOffIcon,
} as const

/** Icônes proposées pour les enveloppes (sélecteur d'icône). */
export const envelopeIcons = {
  wallet: Wallet01Icon,
  rent: Home01Icon,
  building: Building03Icon,
  groceries: ShoppingBag01Icon,
  restaurant: Restaurant01Icon,
  coffee: Coffee02Icon,
  car: Car01Icon,
  bus: Bus01Icon,
  taxi: TaxiIcon,
  motorbike: Motorbike01Icon,
  fuel: FuelIcon,
  plane: PlaneIcon,
  health: Medicine02Icon,
  hospital: Hospital01Icon,
  school: School01Icon,
  books: Book02Icon,
  gift: GiftIcon,
  party: PartyIcon,
  games: GameController03Icon,
  music: Music01Icon,
  cinema: Film02Icon,
  phone: SmartPhone01Icon,
  internet: InternetAntenna01Icon,
  electricity: ElectricHome01Icon,
  water: WaterPumpIcon,
  gas: GasStoveIcon,
  repairs: Wrench01Icon,
  clothes: TShirtIcon,
  baby: Baby01Icon,
  love: HeartIcon,
  pets: PawPrintIcon,
  sport: Dumbbell01Icon,
  church: ChurchIcon,
  mosque: Mosque01Icon,
  savings: PiggyBankIcon,
  goal: Target02Icon,
  bank: BankIcon,
  work: Briefcase01Icon,
  cash: Cash01Icon,
  plants: Plant01Icon,
  celebration: BirthdayCakeIcon,
  tickets: Ticket01Icon,
} as const

export const icons = { ...interfaceIcons, ...envelopeIcons } as const

export type IconName = keyof typeof icons
export type EnvelopeIconName = keyof typeof envelopeIcons

export function isEnvelopeIcon(name: string): name is EnvelopeIconName {
  return Object.hasOwn(envelopeIcons, name)
}
